import './index.scss'

const InputMessage = ({error, displayError, message, information}) => (
    <span className='input-message'>
    <p class="message">
        {error && displayError && 
        <span className="icon xsmall" style={{ WebkitMaskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)', maskImage: 'url(https://static.tui.com/assets/v2/icons/tui-light/exclamation-mark-circled-filled.svg)', color: 'currentcolor' }}>
        </span> 
        }
        
        {error && displayError ? error : message || ''}
        </p>
                {information && <p>{information}</p>}
    </span>
    
)

export default InputMessage;
/*}
    <span className='input-message'>
        <p className={`${error ? 'input-message--error' : ''}`}>{error && displayError ? error : message || ''}</p>
        {information && <p>{information}</p>}
</span>{*/